import { replaceToken } from "./utils";

((Drupal, drupalSettings) => {
  /**
   * Try and get the person token from localStorage.
   * @returns {string|null} Person token if exists in localStorage, null otherwise.
   */
  function getTokenFromStorage() {
    const params = new URLSearchParams(window.location.search);

    if (params.get("check_logged_in") === "1") {
      return null;
    }

    return localStorage.getItem("person_token") || null;
  }

  /**
   * Try and get the person token from query string.
   * @returns {string|null} Person token if exists in query string, null otherwise.
   */
  function getTokenFromQuery() {
    const params = new URLSearchParams(window.location.search);

    return params.get("PT") || null;
  }

  /**
   * Cache a person token into localStorage.
   * @param {string} token The person token to store.
   */
  function saveTokenToStorage(token) {
    try {
      localStorage.setItem("person_token", token);
    } catch (error) {
      console.warn("Could not save person_token to localStorage", error);
    }
  }

  /**
   * Replace person token tokens with the real value within drupalSettings object.
   * @param {string} token The person token value
   * @param {object} settings DrupalSettings object
   */
  function replaceInDrupalSettings(token, settings = drupalSettings) {
    replaceToken(settings, "[analytics_token:person_token]", token);
  }

  if (!drupalSettings.analytics_tokens) {
    drupalSettings.analytics_tokens = {};
  }

  drupalSettings.analytics_tokens.personTokenPromise = new Promise(
    (resolve, reject) => {
      let token = getTokenFromQuery();

      if (token) {
        saveTokenToStorage(token);

        replaceInDrupalSettings(token);

        resolve(token);

        return;
      }

      // Fallback to localStorage.
      token = getTokenFromStorage();

      if (token) {
        replaceInDrupalSettings(token);

        resolve(token);

        return;
      }

      // Don’t call API if user is anonymous
      if (!drupalSettings.user || drupalSettings.user.uid === 0) {
        console.info("Person token not fetched: anonymous user.");

        resolve(null);

        return;
      }

      // Fetch from API.
      fetch("/api/analytics/user/info")
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Failed to load person token: ${response.status} ${response.statusText}`,
            );
          }

          return response.json();
        })
        .then((data) => {
          token = data.person_token;

          saveTokenToStorage(token);

          replaceInDrupalSettings(token);

          resolve(token);
        })
        .catch((err) => {
          console.error("Person token fetch error:", err);

          reject(err);
        });
    },
  );

  Drupal.behaviors.replacePersonToken = {
    attach: async (context, settings) => {
      const token = await settings.analytics_tokens.personTokenPromise;

      replaceInDrupalSettings(token, settings);
    },
  };
})(Drupal, drupalSettings);
